module.exports = __webpack_public_path__ + "img/dep_bakery.e4130e83.png";